/* =====================================================
   MIRROR HOUSE — SHOPIFY THEME JS
   ===================================================== */

(function () {
  'use strict';

  /* ── CART DRAWER ── */
  const cartToggle   = document.getElementById('cart-toggle');
  const cartClose    = document.getElementById('cart-close');
  const cartOverlay  = document.getElementById('cart-overlay');
  const cartDrawer   = document.getElementById('cart-drawer');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose)  cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ── FETCH HELPERS ── */
  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    return res.json();
  }

  async function changeCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  /* ── RENDER CART ── */
  function renderCart(cart) {
    const itemsEl    = document.getElementById('cart-items');
    const countEl    = document.getElementById('cart-count');
    const subtotalEl = document.getElementById('cart-subtotal');

    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-img">
          ${item.featured_image
            ? `<img src="${item.featured_image.url}" alt="${escapeHtml(item.title)}" loading="lazy">`
            : ''}
        </div>
        <div class="cart-item-info">
          <p class="cart-item-name">${escapeHtml(item.product_title)}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item-variant">${escapeHtml(item.variant_title)}</p>`
            : ''}
          <p class="cart-item-price">${formatMoney(item.price)}</p>
        </div>
        <div class="cart-item-qty">
          <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
          <span class="qty-val">${item.quantity}</span>
          <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
        </div>
      </div>
    `).join('');

    // Bind qty buttons
    itemsEl.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        await changeCartItem(key, Math.max(0, qty));
        refreshCart();
      });
    });
  }

  async function refreshCart() {
    const cart = await fetchCart();
    renderCart(cart);
  }

  /* ── AJAX ADD TO CART ── */
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.classList.contains('prod-atc-form')) return;
    e.preventDefault();

    const btn       = form.querySelector('button[type="submit"]');
    const idInput   = form.querySelector('input[name="id"]');
    const variantId = idInput ? idInput.value : null;
    if (!variantId) return;

    const qtyInput = form.querySelector('input[name="quantity"]');
    const qty      = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    try {
      await addToCart(variantId, qty);
      showToast('Added to cart');
      openCart();
    } catch (err) {
      showToast('Could not add item');
    } finally {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });

  /* ── PRODUCT PAGE — VARIANT SELECTOR ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    const variantIdInput = document.getElementById('variant-id');
    const selects = productForm.querySelectorAll('.option-select');

    selects.forEach(sel => {
      sel.addEventListener('change', () => {
        // Build selected options array
        const options = Array.from(selects).map(s => s.value);
        // Find matching variant via window.productVariants if embedded
        if (window.__mh_variants) {
          const match = window.__mh_variants.find(v =>
            v.options.every((o, i) => o === options[i])
          );
          if (match && variantIdInput) {
            variantIdInput.value = match.id;
            const priceEl = document.getElementById('product-price');
            if (priceEl) priceEl.querySelector('.price-current').textContent = formatMoney(match.price);
          }
        }
      });
    });
  }

  /* ── COLLECTION FILTER ── */
  window.filterProds = function (btn, tag) {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    document.querySelectorAll('.prod-card').forEach(card => {
      if (tag === 'all') {
        card.style.display = '';
      } else {
        const tags = (card.dataset.tags || '').split(',').map(t => t.trim());
        card.style.display = tags.includes(tag) ? '' : 'none';
      }
    });
  };

  /* ── TOAST ── */
  let toastTimer;
  function showToast(msg) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2800);
  }
  window.showToast = showToast;

  /* ── HELPERS ── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(str) {
    const d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  /* ── NAV DROPDOWN ── */
  document.querySelectorAll('.nav-dropdown').forEach(function (dropdown) {
    const toggle = dropdown.querySelector('.nav-dropdown-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('open');
      // close all others first
      document.querySelectorAll('.nav-dropdown.open').forEach(function (d) {
        d.classList.remove('open');
        const t = d.querySelector('.nav-dropdown-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        dropdown.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.nav-dropdown.open').forEach(function (d) {
      d.classList.remove('open');
      const t = d.querySelector('.nav-dropdown-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── MOBILE HAMBURGER ── */
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.contains('open');
      if (isOpen) {
        mobileMenu.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      } else {
        mobileMenu.classList.add('open');
        hamburger.classList.add('open');
        hamburger.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
      }
    });
    // Close mobile menu when a link is tapped
    mobileMenu.querySelectorAll('.mobile-menu-link').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ── HEADER SCROLL ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 16);
    }, { passive: true });
  }

  // Initial cart count on load
  fetchCart().then(cart => {
    const countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = cart.item_count;
  });

})();
